/* assets/ai-art-logic.js | AI Variant Manager Compatible */

window.aiGenerating=false;


/* ================================
AI 初始化
================================ */

document.addEventListener("DOMContentLoaded",function(){

    renderHistory();

    const container=document.getElementById("frame-display-container");

    if(container){

        container.classList.add("mode-framed");

        const config=window.ART_CONFIG.get(window.CURRENT_SKU);

        const initialColor=
        (config&&config.selectedFrame)
        ?config.selectedFrame
        :"black";

        if(config&&config.frameImages){

            container.style.backgroundImage=
            `url('${config.frameImages[initialColor]}')`;

        }

    }

});



/* ================================
Preview Engine
================================ */

const ZalandaEngine={

generatePreviewUrl:function(hdUrl){

    if(!hdUrl||typeof hdUrl!=="string"){
        return hdUrl;
    }


    if(!hdUrl.includes("cloudinary.com")){
        return hdUrl;
    }


    try{

        const transformation=
"w_800,c_limit,q_auto:eco/co_rgb:FFFFFF,l_text:Arial_46:THIS%20MOMENT%20IS%20SACRED,o_40,g_center,y_-30/co_rgb:FFFFFF,l_text:Arial_42:NOT%20A%20TOY,o_40,g_center,y_30";


        if(hdUrl.includes("/upload/")){

            return hdUrl.replace(
                "/upload/",
                `/upload/${transformation}/`
            );

        }


        return hdUrl;


    }catch(err){

        console.error(err);

        return hdUrl;

    }

},



prepareCartData:function(hd,preview){

    const hdInput=
    document.getElementById(
        "hd-url-property"
    );


    const previewInput=
    document.getElementById(
        "preview-url-property"
    );


    if(hdInput){

        hdInput.value=hd;

    }


    if(previewInput){

        previewInput.value=preview;

    }

}

};





window.ZalandaCartManager={

activeSession:{

    hdUrl:null,

    previewUrl:null

},


updateState:function(hd,preview){

    this.activeSession.hdUrl=hd;

    this.activeSession.previewUrl=preview;


    AI_STORAGE.set(
        "latest_creation",
        this.activeSession
    );

}

};





/* ================================
Add To Cart
================================ */

window.applyAndAddToCart=function(
hd,
preview,
btnElement,
specificVid
){


sendZalandaPixel(
"User_Initial_Intent"
);



const realPreview =
ZalandaEngine.generatePreviewUrl(
hd
);



const activeSetup =
getActiveSetup();



const variantId =
specificVid ||
document.getElementById(
"dynamic-variant-id"
)?.value;



btnElement.innerHTML =
"Processing...";





const gift =
window.AI_GIFT_MESSAGE || {};





const payload={

items:[{

id:variantId,

quantity:1,

properties:{


"_AI_Production_Url":
hd,


"_Preview_Image_Url":
realPreview,



"Design Style":
activeSetup?.product?.name || "",




"_Gift_Name":
gift.name || "",



"_Gift_Date":
gift.date || "",



"_Gift_Message":
gift.message || ""



}

}]

};





fetch(
"/cart/add.js",
{

method:"POST",

headers:{

"Content-Type":
"application/json"

},

body:
JSON.stringify(payload)

}

)

.then(res=>res.json())

.then(data=>{


if(data.id||data.items){


AI_STORAGE.remove(
"latest_creation"
);


setTimeout(() => {
  window.location.href = "/cart";
}, 1000);


}else{


btnElement.innerHTML=
"Add to Cart";


}


})


.catch(err=>{


console.error(err);



document
.getElementById(
"ai-cart-form"
)
?.submit();



});


};
/* ================================
History
================================ */

function saveToHistory(newUrl){

    const previewUrl=
    ZalandaEngine.generatePreviewUrl(
        newUrl
    );




    let history =
    AI_STORAGE.get(
    "creations",
    []
);


    if(
        history.find(
            item=>item.hd===newUrl
        )
    ){

        return;

    }


    history.unshift({

        hd:newUrl,

        preview:previewUrl

    });


    AI_STORAGE.set(
        "creations",
    history.slice(0,8)
    );



    syncArtToUI(
        newUrl,
        previewUrl
    );


    renderHistory();

}





function renderHistory(){


    const thumbsRow =
    document.getElementById(
        "thumbs-row"
    );


    if(!thumbsRow){

        return;

    }





    let history =
    AI_STORAGE.get(
    "creations",
    []
);




    /*
    清空当前缩略图
    */

    thumbsRow.innerHTML="";






    /*
    删除旧按钮
    防止重复生成
    */

    const oldClearBtn =
    document.querySelector(
        ".clear-history-btn"
    );


    if(oldClearBtn){

        oldClearBtn.remove();

    }






    /*
    渲染历史作品
    */

    history.forEach(
    (item,index)=>{


        const thumb =
        document.createElement(
            "img"
        );



        thumb.src =
        item.preview;



        thumb.style.cssText =
        `
        width:70px;
        height:70px;
        cursor:pointer;
        border-radius:8px;
        border:2px solid #ccc;
        object-fit:cover;
        `;





        thumb.onclick=function(){


            syncArtToUI(
                item.hd,
                item.preview
            );


        };





        thumbsRow.appendChild(
            thumb
        );


    });








    /*
    如果有历史作品
    默认显示第一张
    */

    if(history.length){



        syncArtToUI(
            history[0].hd,
            history[0].preview
        );





        /*
        创建删除按钮
        */


        const clearBtn =
        document.createElement(
            "button"
        );



        clearBtn.className =
        "clear-history-btn";



        clearBtn.innerText =
        "Remove all creations";






        clearBtn.onclick=function(){



            const confirmDelete =
            confirm(
            "Remove all saved creations?"
            );



            if(!confirmDelete){

                return;

            }





            /*
            删除历史记录
            */

            AI_STORAGE.remove(
                "creations"
            );





            /*
            清空缩略图
            */

            thumbsRow.innerHTML="";






            /*
            清空主预览
            */


            const mainPreview =
            document.getElementById(
                "main-preview"
            );


            if(mainPreview){

                mainPreview.src="";

            }





            /*
            清空框架预览
            */


            const frameDisplayCore =
            document.getElementById(
                "frame-display-core"
            );


            if(frameDisplayCore){

                frameDisplayCore.src="";

                frameDisplayCore.style.display="none";

            }





            /*
            清除当前状态
            */


            window.currentArtworkPreview="";



            if(window.ZalandaCartManager){

                window.ZalandaCartManager.activeSession.hdUrl=null;

                window.ZalandaCartManager.activeSession.previewUrl=null;

            }





            /*
            隐藏作品区域
            */

            const gallery =
            document.getElementById(
                "multi-results-container"
            );


            if(gallery){

                gallery.classList.add(
                    "ai-gallery-hidden"
                );

            }



            const wallPreview =
            document.getElementById(
                "ai-wall-preview-wrapper"
            );


            if(wallPreview){

                wallPreview.classList.add(
                    "ai-gallery-hidden"
                );

            }




            clearBtn.remove();



        };






        thumbsRow.parentElement.appendChild(
            clearBtn
        );



    }





}




function syncArtToUI(hd,preview){


    const mainPreview=
    document.getElementById(
        "main-preview"
    );


    if(mainPreview){

        mainPreview.src=
        preview;

    }



    window.currentArtworkPreview=
    preview;



    const frameDisplayCore=
    document.getElementById(
        "frame-display-core"
    );



    if(frameDisplayCore){

        frameDisplayCore.src=
        preview;


        frameDisplayCore.style.display=
        "block";

    }



    ZalandaEngine.prepareCartData(
        hd,
        preview
    );



    ZalandaCartManager.updateState(
        hd,
        preview
    );



    // 打开生成后的作品区域

    document
    .getElementById(
        "multi-results-container"
    )
    ?.classList.remove(
        "ai-gallery-hidden"
    );



    document
    .getElementById(
        "ai-wall-preview-wrapper"
    )
    ?.classList.remove(
        "ai-gallery-hidden"
    );


}






/* ================================
Variant Adapter
================================ */

function clickShopifyVariant(value){

    console.log(
        "[Variant Adapter]",
        value
    );


    if(!window.AI_VARIANT_MANAGER){

        console.error(
            "AI_VARIANT_MANAGER missing"
        );


        return false;

    }



    return window.AI_VARIANT_MANAGER.select({

        option1:value

    });

}





/* ================================
Frame Mode
================================ */

function aiArtToggleFrameMode(isFramed){

    const container=
    document.getElementById(
        "frame-display-container"
    );


    const optionsWrapper=
    document.getElementById(
        "frame-options-wrapper"
    );


    const config=
    window.ART_CONFIG.get(
        window.CURRENT_SKU
    );



    if(isFramed){


        container.classList.replace(
            "mode-canvas",
            "mode-framed"
        );



        optionsWrapper.style.display=
        "flex";



        const currentColor=
        config.selectedFrame||
        "black";



        const activeButton=
        document.querySelector(
            `.frame-swatch[onclick*="${currentColor}"]`
        );



        updateFrame(
            currentColor,
            activeButton
        );



    }else{


        container.classList.replace(
            "mode-framed",
            "mode-canvas"
        );



        optionsWrapper.style.display=
        "none";



        container.style.backgroundImage=
        `url('${config.assets.canvasBg}')`;



        clickShopifyVariant(
            "Canvas Only"
        );


    }

}
/* ================================
Shopify Submit Interceptor
================================ */

document.addEventListener(
"submit",
function(event){

    const form=
    event.target;


    if(
        form.getAttribute("action")!=="/cart/add"
    ){

        return;

    }


    const hd=
    document.getElementById(
        "hd-url-property"
    )?.value;


    const preview=
    document.getElementById(
        "preview-url-property"
    )?.value;


    if(
        !hd||
        !preview
    ){

        return;

    }


    [
        {
            name:"properties[_AI_Production_Url]",
            value:hd
        },
        {
            name:"properties[_Preview_Image_Url]",
            value:preview
        }

    ]
    .forEach(item=>{


        if(
            !form.querySelector(
                `input[name="${item.name}"]`
            )
        ){


            const input=
            document.createElement(
                "input"
            );


            input.type=
            "hidden";


            input.name=
            item.name;


            input.value=
            item.value;


            form.appendChild(
                input
            );


        }


    });


},
true);





/* ================================
AI Lock
================================ */

window.AIProcessManager={

    generating:false,


    start:function(){

        if(this.generating){

            return false;

        }


        this.generating=true;


        this.lockButtons();


        return true;

    },


    finish:function(){

        this.generating=false;


        this.unlockButtons();

    },


    lockButtons:function(){

        document
        .querySelectorAll(
            ".art-main-submit-btn,.new-version-btn"
        )
        .forEach(btn=>{

            btn.disabled=true;


            btn.classList.add(
                "ai-button-disabled"
            );

        });

    },


    unlockButtons:function(){

        document
        .querySelectorAll(
            ".art-main-submit-btn,.new-version-btn"
        )
        .forEach(btn=>{

            btn.disabled=false;


            btn.classList.remove(
                "ai-button-disabled"
            );

        });

    }

};





/* ================================
Try Version
================================ */

document.addEventListener(
"DOMContentLoaded",
function(){


    const tryBtn =
    document.querySelector(
        ".new-version-btn"
    );


    if(!tryBtn){

        return;

    }





    tryBtn.addEventListener(
    "click",
    function(){



        if(
            window.AIProcessManager &&
            window.AIProcessManager.generating
        ){

            return;

        }






        const createBtn =
        document.querySelector(
            ".art-main-submit-btn"
        );




        if(!createBtn){

            return;

        }





        /*
        先滚动到 Create artwork 按钮位置

        目的:
        用户点击 Try new version 后，
        马上看到：
        Create artwork状态
        +
        Creating your artwork
        +
        Progress

        */

        const targetY =
        createBtn.getBoundingClientRect().top
        +
        window.scrollY
        -
        20;



        window.scrollTo({

            top:targetY,

            behavior:"smooth"

        });








        /*
        等滚动启动后再触发生成

        防止:
        滚动动画
        +
        AI状态变化
        同时发生导致视觉跳动

        */


        setTimeout(
        function(){


            createBtn.click();


        },
        500
        );



    });


});